import {
  API_STATUS_READY,
  API_STATUS_CREATING,
  createAPIReducer,
} from '../../lib/redux';

const reducer = createAPIReducer('zoomlevels');

export default reducer;

export const ZOOMLEVEL_STATUS_READY = API_STATUS_READY;
export const ZOOMLEVEL_STATUS_CREATING = API_STATUS_CREATING;
